module.exports = __webpack_public_path__ + "d2d27d20483d4a4a8e5b1c423a4d63d7.svg";


//////////////////
// WEBPACK FOOTER
// ./~/flag-icon-css/flags/1x1/sa.svg
// module id = ./node_modules/flag-icon-css/flags/1x1/sa.svg
// module chunks = 0